import { ref, watch, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from './store';
import { useAccount } from './useAccount';

const TOGGLE_INTERVAL = 1000; // 1 seconds

export function useDocumentTitle() {
  const { t } = useI18n();
  const { currentAccount } = useAccount();
  const conversationStats = useMapGetter('conversationStats/getStats');

  const toggleTimer = ref(null);
  const showUnread = ref(false);

  const clearToggleTimer = () => {
    if (toggleTimer.value) {
      clearInterval(toggleTimer.value);
      toggleTimer.value = null;
    }
  };

  const startToggling = () => {
    clearToggleTimer();
    showUnread.value = false;
    toggleTimer.value = setInterval(() => {
      showUnread.value = !showUnread.value;
      updateTitle();
    }, TOGGLE_INTERVAL);
  };

  const updateTitle = () => {
    const accountName = currentAccount.value?.name;
    const count = conversationStats.value?.allUnreadMessagesCount || 0;

    if (!accountName) return;

    if (count > 0 && showUnread.value) {
      document.title = `(${count}) ${t('GENERAL.NEW_MESSAGES')}`;
    } else {
      document.title = accountName;
    }
  };

  // Watch unread count to start/stop toggling
  watch(
    () => conversationStats.value?.allUnreadMessagesCount || 0,
    newCount => {
      if (newCount > 0) {
        startToggling();
        updateTitle();
      } else {
        clearToggleTimer();
        showUnread.value = false;
        updateTitle();
      }
    },
    { immediate: true }
  );

  // Watch account name changes
  watch(
    () => currentAccount.value?.name,
    () => {
      updateTitle();
    }
  );

  onUnmounted(() => {
    clearToggleTimer();
  });

  return {
    updateTitle,
  };
}
